export const uk = {
    isNotSet: 'не задан',
    perDay: 'в день'
};
